export type TPatronLevel = {
  level: number;
  name: string;
  slug: string;
};

export const PATRON_LEVELS: Record<string, TPatronLevel> = {
  premium_1: { level: 1, name: 'Friendly', slug: 'friendly' },
  premium_2: { level: 2, name: 'Honored', slug: 'honored' },
  premium_3: { level: 3, name: 'Revered', slug: 'revered' },
  premium_4: { level: 4, name: 'Exalted', slug: 'exalted' },
  premium_5: { level: 5, name: 'Illustrious', slug: 'illustrious' },
  admin: { level: 5, name: 'Admin', slug: 'admin' }
};

export function getHighestPatronLevelFromFeatures(features: readonly string[]): TPatronLevel | null {
  const activeFeatures = new Set(features);
  let highestLevel: TPatronLevel | null = null;

  for (const [feature, patronLevel] of Object.entries(PATRON_LEVELS)) {
    if (activeFeatures.has(feature) && (!highestLevel || patronLevel.level >= highestLevel.level)) {
      highestLevel = patronLevel;
    }
  }

  return highestLevel;
}
